// One approval card per session for cyborg7_message (Fab, 2026-10-09; server message-approval-group.ts).

export const MESSAGE_TOOL_CALL = "mcp__cyborg7__cyborg7_message";

/** Server APPROVAL_DENIED_TEXT, the same words. */
export const APPROVAL_DENIED_TEXT =
  "Error (approval_denied): the person you work for did not allow messages from this session. " +
  "Nothing was sent; do not send it again in this turn.";

export const CARD_LIST_MAX = 5;

/** Only Claude's exact tool name groups: Codex names no tool, an ACP agent names its own. */
export function isMessageApproval(r: { name: string; provider: string }): boolean {
  return r.provider === "claude" && r.name === MESSAGE_TOOL_CALL;
}

export function splitMessageApprovals<T extends { name: string; provider: string }>(
  requests: readonly T[],
): { card: T[]; rest: T[] } {
  const card: T[] = [];
  const rest: T[] = [];
  for (const r of requests) (isMessageApproval(r) ? card : rest).push(r);
  return { card, rest };
}

export function messageApprovalLine(r: { input?: Record<string, unknown> }): {
  to: string;
  firstLine: string;
} {
  const to = typeof r.input?.to === "string" ? r.input.to.trim() : "";
  const text = typeof r.input?.text === "string" ? r.input.text : "";
  const firstLine =
    text
      .split("\n")
      .map((l) => l.trim())
      .find(Boolean) ?? "";
  return { to, firstLine };
}

export interface MessageApprovalCopy {
  title: string;
  subtitle: string;
  /** "and {n} more" past CARD_LIST_MAX, else undefined. */
  more: string | undefined;
  footnote: string;
}

export function messageApprovalCopy(session: string, count: number): MessageApprovalCopy {
  const extra = count - CARD_LIST_MAX;
  return {
    title: `Let ${session} send messages?`,
    subtitle: "Nothing is sent until you answer.",
    more: extra > 0 ? `and ${extra} more` : undefined,
    footnote:
      `Allow covers every message ${session} sends until this session ends. ` +
      (count === 1 ? "Deny covers this one." : `Deny covers the ${count} above.`),
  };
}

/** A message that joins a waiting card raises no alert of its own: the card alerted once. */
export function joinsWaitingMessageCard(
  request: { id: string; name: string; provider: string },
  waiting: ReadonlyArray<{ id: string; name: string; provider: string }>,
): boolean {
  return (
    isMessageApproval(request) && waiting.some((w) => w.id !== request.id && isMessageApproval(w))
  );
}
